"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendEvent;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSendEvent() {
  return (0, _useWebChatAPIContext.default)().sendEvent;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTZW5kRXZlbnQiLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsInNlbmRFdmVudCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVNlbmRFdmVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNlbmRFdmVudCgpOiAobmFtZTogc3RyaW5nLCB2YWx1ZTogYW55KSA9PiB2b2lkIHtcbiAgcmV0dXJuIHVzZVdlYkNoYXRBUElDb250ZXh0KCkuc2VuZEV2ZW50O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxZQUFULEdBQTREO0VBQ3pFLE9BQU8sSUFBQUMsNkJBQUEsSUFBdUJDLFNBQTlCO0FBQ0QifQ==